import { render, staticRenderFns } from "./helpPdf.vue?vue&type=template&id=211c3453&"
import script from "./helpPdf.vue?vue&type=script&lang=js&"
export * from "./helpPdf.vue?vue&type=script&lang=js&"
import style0 from "./helpPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211c3453')) {
      api.createRecord('211c3453', component.options)
    } else {
      api.reload('211c3453', component.options)
    }
    module.hot.accept("./helpPdf.vue?vue&type=template&id=211c3453&", function () {
      api.rerender('211c3453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/helpDoc/helpPdf.vue"
export default component.exports